import React from 'react';

import TabStrip from '../shared/TabStrip';

import { useDealInformationTabCounts } from './DealInformationTabCounts';
import { DEAL_INFORMATION_TABS } from './constants';
import type { DealInformationTab } from './types';

interface Props {
  activeTab: DealInformationTab;
  onTabChange: (tab: DealInformationTab) => void;
}

export default function DealInformationToolbar({ activeTab, onTabChange }: Props) {
  const counts = useDealInformationTabCounts();

  return <TabStrip activeTab={activeTab} counts={counts} onTabChange={onTabChange} tabs={DEAL_INFORMATION_TABS} />;
}
